import { useQuery } from '@tanstack/react-query'
import { reactQueryRequest } from 'api/makeQuery'

const useTicketDetails = (ticketId: string) => {
  const { data, isLoading, isError, isPlaceholderData } = useQuery({
    queryKey: ['ticketDetails', ticketId],
    queryFn: () =>
      reactQueryRequest('getTicketDetails', {
        ticketId,
      }),
    enabled: !!ticketId,
  })

  return {
    ticketDetails: data,
    isLoading,
    isError,
    isPlaceholderData,
  }
}

export default useTicketDetails
